import { client } from 'f';

function isUserActivationSupported() {
  // Ensure this code only runs in a client-side environment
  if (!client) {
    return false;
  }

  return !!navigator.userActivation;
}

function getUserActivationState() {
  // Again, ensure this code only runs on the client side
  if (!client) {
    return false;
  }

  if (
    isUserActivationSupported() &&
    typeof navigator.userActivation.hasBeenActive !== 'undefined'
  ) {
    return navigator.userActivation.hasBeenActive;
  }

  // Default fallback for browsers that do not support userActivation.
  return false;
}

function getParentUrl(): string | null {
  if (typeof window === 'undefined') return null;

  try {
    const parentUrl = document.referrer;
    return parentUrl ? new URL(parentUrl).toString() : null;
  } catch (error) {
    console.error('Invalid parent URL:', error);
    return null;
  }
}

export { getParentUrl, getUserActivationState, isUserActivationSupported };
